import { Cartable } from "../../shared/providers/cart.provider";
import * as md5             from 'md5';


export abstract class Calculation implements Cartable
{
  public name                  : string = '';
  public unit                  : string = 'metric';

  public eqCapacity            : number    = null;
  public workingHours          : number    = null;
  public workingDays           : number    = null;
  public workingMonths         : number    = null;
  public eqCapacityUnit        : string    = 'cycle/min';
  public workingHoursUnit      : string    = 'hours/day';
  public workingDaysUnit       : string    = 'days/month';
  public workingMonthsUnit     : string    = 'months/year';

  get eqCapacityFormatted() : string { return this.formatNumberWithSpaces(this.eqCapacity)};
  get workingHoursFormatted() : string { return this.formatNumberWithSpaces(this.workingHours)};
  get workingDaysFormatted()    : string { return this.formatNumberWithSpaces(this.workingDays)};
  get workingMonthsFormatted()     : string { return this.formatNumberWithSpaces(this.workingMonths)};

  get consumptionPerPackageFormatted() : string { return this.formatNumberWithSpaces(this.consumptionPerPackage)};
  get instantaneousFlowRateFormatted() : string { return this.formatNumberWithSpaces(this.instantaneousFlowRate)};
  get monthlyConsumptionFormatted()    : string { return this.formatNumberWithSpaces(this.monthlyConsumption)};
  get yearlyConsumptionFormatted()     : string { return this.formatNumberWithSpaces(this.yearlyConsumption)};

  get consumptionPerPackageUnit() : string { return this.unit === 'metric' ? 'liter/package' : 'in3/package' };
  get instantaneousFlowRateUnit() : string { return this.unit === 'metric' ? 'm3/hour' : 'ft3/hour' };
  get monthlyConsumptionUnit()    : string { return this.unit === 'metric' ? 'm3/month' : 'ft3/month' };
  get yearlyConsumptionUnit()     : string { return this.unit === 'metric' ? 'm3/year' : 'ft3/year' };

  abstract get effectiveVolume()       : number;
  abstract get consumptionPerPackage() : number;

  get instantaneousFlowRate() : number { return Math.round(this.effectiveVolume * this.eqCapacity * 60 /1000) };
  get monthlyConsumption()    : number { return Math.round(this.effectiveVolume * this.eqCapacity * 60 * this.workingHours * this.workingDays / (this.unit === 'metric' ? 1000 : 1/0.000578704)) };
  get yearlyConsumption()     : number { return Math.round(this.monthlyConsumption * this.workingMonths) };

  constructor(obj : any)
  {
    if (!obj) return;

    this.name              = obj.name;
    this.unit              = obj.unit;
    this.eqCapacity        = obj.eqCapacity;
    this.eqCapacityUnit    = obj.eqCapacityUnit;
    this.workingHours      = obj.workingHours;
    this.workingHoursUnit  = obj.effectiveHoursUnit;
    this.workingDays       = obj.workingDays;
    this.workingDaysUnit   = obj.workingDaysUnit;
    this.workingMonths     = obj.workingMonths;
    this.workingMonthsUnit = obj.workingMonthsUnit;
  }

  getBusinessCode(): string {
    return md5(`${this.name}_${this.consumptionPerPackage}_${this.instantaneousFlowRate}_${this.monthlyConsumption}_${this.yearlyConsumption}`) ;
  }

  protected formatNumberWithSpaces(initial : number)
  {
    return initial.toString().replace(/\B(?=(\d{3})+\b)/g, " ");
  }

}

export class VacuumCalculation extends Calculation
{
  vacuumChamber         : number    = null;
  packagePerCycle       : number    = null;
  flowRate              : number    = null;
  packagePerCycleUnit   : string    = 'No/cycle';

  get vacuumChamberFormatted() : string { return this.formatNumberWithSpaces(this.vacuumChamber)};
  get packagePerCycleFormatted() : string { return this.formatNumberWithSpaces(this.packagePerCycle)};

  get effectiveVolume()       : number { return this.vacuumChamber };
  get vacuumChamberUnit()     : string { return this.unit === 'metric' ? 'liter'       : 'in3' };
  get effectiveVolumeUnit()   : string { return this.unit === 'metric' ? 'liter/cycle' : 'in3/cycle' };
  get flowRateUnit()          : string { return this.unit === 'metric' ? 'm3/hour'     : 'ft3/hour' };

  get consumptionPerPackage() : number { return Math.round(this.effectiveVolume / this.packagePerCycle) };

  constructor(obj : any = null)
  {
    super(obj);

    if (!obj) return;

    this.vacuumChamber        = obj.vacuumChamber;
    this.packagePerCycle      = obj.packagePerCycle;
    this.flowRate             = obj.flowRate;
    this.packagePerCycleUnit  = obj.packagePerCycleUnit;
  }
}


export class FlushingCalculation extends Calculation
{
  bagVolume       : number    = null;
  o2accepted      : number    = null;
  eqCapacityUnit  : string    = 'bags/min';

  get bagVolumeFormatted() : string { return this.formatNumberWithSpaces(this.bagVolume)};

  get effectiveVolume()       : number { return this.bagVolume * this.noPurgings };
  get bagVolumeUnit()                : string { return this.unit === 'metric' ? 'liter' : 'in3' };
  get dilutionVolumeUnit()           : string { return this.unit === 'metric' ? 'liter/bag' : 'in3/bag' };
  get instantaneousConsumptionUnit() : string { return this.unit === 'metric' ? 'm3/hour' : 'ft3/hour' };

  get consumptionPerPackage() : number { return Math.round(this.effectiveVolume) };

  get noPurgings()            : number
  {
    switch(this.o2accepted)
    {
      case 8:   return 1;
      case 3:   return 2;
      case 2:   return 3;
      case 1:   return 3;
      default:  return 4;
    }
  }

  constructor(obj : any = null)
  {
    super(obj);

    if (!obj) return;

    this.bagVolume      = obj.bagVolume;
    this.o2accepted     = obj.o2accepted;
    this.eqCapacityUnit = obj.eqCapacityUnit;
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/calculator-results/calculation.provider.ts